import React, { useState, useEffect } from 'react'
import Header from "components/Headers/Header.js";
import { Card, CardHeader, CardBody, Container, Row, Col, Spinner, CardFooter, Button, Table} from "reactstrap";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import axios from 'axios'
import {Link} from 'react-router-dom'
import { format } from 'date-fns'; 
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

function DamageInsuranceList() {
  
  const [loading, setLoading]=useState(true)
  const [damage, setDamage]=useState([])

  const [loadingsubmit, setLoadingsubmit]=useState(true)

  const token = useSelector((state) => state.userLogin.userInfo.token);

  ////////////
  const { t, i18n } = useTranslation();  

  useEffect(() => {
    const storedLanguage = localStorage.getItem('selectedLanguageAFS');
    if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
  }, [i18n]);
  ////////////

  useEffect(() => {

    const fetchData = async () => {

      try {
        const config = {
          headers: {
            'Content-type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
        
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/damage-list-insurance/`, config);

        setDamage(response.data)

      } catch (error) {
          
        console.log(error)

      } finally {
        setLoading(false)
      }
    };

    fetchData(); 
  }, [token]);

  const submitdata = async(id) => {

    setLoadingsubmit(false)    

    try {
      const config = {
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }
      
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/damage-insurance-completed/${id}`, config);

    } catch (error) {
        
      console.log(error)

    } finally {
      setLoadingsubmit(true)
      window.location.reload();
    }

  }

  return (
    <div>
      <Header/>
      {loading ? (
        <>
          <Container className="mt--15" fluid>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                <Spinner>
                  {t('Loading')}
                </Spinner>
              </Col>
            </Row>
          </Container>
        </>
      ):(
        <>
          <Container className="mt--15" fluid>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                {damage && damage.length > 0 ? (
                  <>
                    <Card>
                      <CardHeader>
                        <h3>{t('Damage List')}</h3>
                      </CardHeader>
                      <CardBody>
                        <Table
                          className="align-items-center table-flush"
                          responsive>
                          <thead>
                            <tr>
                              <th>{t('Date')}</th>
                              <th>{t('Type of Damage')}</th>
                              <th>{t('Note of the Damage')}</th>
                              <th>{t('Sensor')}</th> 
                              <th>{t('User')}</th> 
                              <th>{t('Completed or Solved')}</th> 
                              <th>{t('Complete')}</th>                  
                            </tr>
                          </thead>
                          <tbody>
                            {damage.map((farmer) => (
                              <tr key={farmer.id}>
                                <td>{format(new Date(farmer.date), 'dd/MM/yyyy')}</td>                                                        
                                <td>{farmer.type_damage}</td>
                                <td>{farmer.text_damage}</td>
                                <td>{farmer.sensor}</td>
                                <td>{farmer.email_normal_user}</td>
                                <td>
                                  {farmer.is_completed ? (
                                    <FaCheckCircle color="green" />
                                  ) : (
                                    <FaTimesCircle color="red" />
                                  )}
                                </td>
                                <td>
                                  {loadingsubmit ? (
                                    <>
                                      {farmer.is_completed ? (
                                        <>
                                          <Button color="success"  disabled>
                                            {t('Completed')} <i class="fa-solid fa-check"></i>
                                          </Button>
                                        </>
                                      ):(
                                        <>
                                          <Button color="success"  onClick={() => submitdata(farmer.id)}>
                                            {t('Sign as completed')} <i class="fa-solid fa-check"></i>
                                          </Button>
                                        </>
                                      )}
                                    </>
                                  ):(
                                    <>
                                      <Button color="success" disabled>
                                        <Spinner size="sm">
                                          {t('Saving...')}
                                        </Spinner>
                                        <span>
                                          {' '}{t('Saving...')}
                                        </span>
                                      </Button>
                                    </>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                      </Table>
                      </CardBody>
                      <CardFooter>
                        <Link to="/connect-insurance-service/">
                          <Button color="primary">
                            {t('Go back')} <i className="fas fa-rotate-left"></i>
                          </Button>
                        </Link>
                      </CardFooter>
                    </Card>
                  </>
                ):(
                  <>
                    <Card>
                      <CardHeader>
                        <h3>{t('Damage List')}</h3>
                      </CardHeader>
                      <CardBody>
                        <h3>{t('No damage is recorded')}</h3>
                      </CardBody>
                      <CardFooter>
                        <Link to="/connect-insurance-service/">
                          <Button color="primary">
                            {t('Go back')} <i className="fas fa-rotate-left"></i>
                          </Button>
                        </Link>
                      </CardFooter>
                    </Card>
                  </>
                )}
              </Col>
            </Row>
          </Container>
        </>
      )}
    </div>
  )
}

export default DamageInsuranceList
